import { ShieldCheck } from '@drift-labs/icons';

export const ProtectedMakerIcon = ({ size = 20 }: { size?: number }) => {
	return (
		<div className="flex size-full items-center justify-center [&_path]:fill-text-default">
			<ShieldCheck size={size} />
		</div>
	);
};
